module.exports = __webpack_public_path__ + "media/images/emblems/Auswil-coat_of_arms-64d8a1fe69f4bb500281c1a527967496.svg";